import { BrowserEventAnalytics, CompositeAnalytics, ConsoleAnalytics, type Analytics } from "./Analytics";
import { PostHogAdapter, type PostHogLike } from "./PostHogAdapter";

type AnalyticsEnv = {
  readonly DEV?: boolean;
  readonly VITE_ANALYTICS_ENABLED?: string;
};

type AnalyticsWindow = Window & {
  posthog?: PostHogLike;
};

export function createAnalytics(playerId: string, env: AnalyticsEnv, root: AnalyticsWindow = window): Analytics {
  const consoleAnalytics = new ConsoleAnalytics(playerId);
  const sinks: Analytics[] = [consoleAnalytics, new BrowserEventAnalytics(root)];
  const enabled = env.VITE_ANALYTICS_ENABLED === "true" && !env.DEV;

  if (enabled && root.posthog) {
    sinks.push(new PostHogAdapter(root.posthog, playerId, consoleAnalytics.sessionId));
  }

  return sinks.length === 1 ? consoleAnalytics : new CompositeAnalytics(sinks);
}
